// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3EX0h","imageUploader":"EGiftCard_imageUploader__2b4h6"};